// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"c9f70fd0","348":"fbb4b043","571":"b59bdcdd","924":"785480f7"}[chunkId] + ".chunk.js";
};